export function formatFullName(firstName, lastName) {
    return `${normalizeFirstName(firstName)} ${normalizeLastName(lastName)}`;
}
/**
 * Normalize a first name to Title Case.
 * Handles hyphens and multi-word names.
 * "JEAN-PIERRE" -> "Jean-Pierre", "marie anne" -> "Marie Anne"
 */
export function normalizeFirstName(name) {
    if (!name)
        return '';
    return name
        .trim()
        .toLowerCase()
        .replace(/(^|[\s-])(\S)/g, (_, separator, char) => separator + char.toUpperCase());
}
/**
 * Normalize a last name to UPPERCASE.
 * "dupont" -> "DUPONT", "de la fontaine" -> "DE LA FONTAINE"
 */
export function normalizeLastName(name) {
    if (!name)
        return '';
    return name.trim().toUpperCase();
}
